/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteTargetAttachment$Params {
  attachmentID?: number;
}

export function DeleteTargetAttachment(http: HttpClient, rootUrl: string, params?: DeleteTargetAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, DeleteTargetAttachment.PATH, 'post');
  if (params) {
    rb.query('attachmentID', params.attachmentID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

DeleteTargetAttachment.PATH = '/api/Supervisor/DeleteTargetAttachment';
